// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__38xS8","right":"Footer_right__3ZNWB","buttons":"Footer_buttons__3CA2B"};